<template>
  <div class="connection-indicator">
    <pre class="m-0 mx-2">{{ text }}</pre>
    <i :class="['bi', 'bi-' + icon, 'text-' + variant]"></i>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ConnectionIndicator',
  props: {
    connected: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    icon(): string {
      return this.connected ? 'lightning-fill' : 'lightning';
    },
    variant(): string {
      return this.connected ? 'success' : 'danger';
    },
    text(): string {
      return this.connected ? 'Connected' : 'Not Connected';
    },
  },
});
</script>
<style scoped>
.connection-indicator {
  display: flex;
  align-items: center;
}

.connection-indicator pre {
  font-size: 75%;
}
</style>
